import { useMutation } from '@tanstack/react-query'
import { AdminService } from '@app/services/adminService'
import { toast } from '@app/components/ui/Toast/toast'

export const useResendAdminInvite = () => {
  return useMutation({
    mutationFn: (email: string) => AdminService.resendInvite(email),
    onSuccess: (_, email) =>
      toast({
        description: `Resent invite to ${email}`,
        type: 'success',
      }),
    onError: () =>
      toast({
        description: `Failed to resend invite.`,
        type: 'error',
      }),
  })
}
